import { render } from "./NovoScanFolhetoTable.vue?vue&type=template&id=11bb4389&scoped=true"
import script from "./NovoScanFolhetoTable.vue?vue&type=script&lang=js"
export * from "./NovoScanFolhetoTable.vue?vue&type=script&lang=js"

import "./NovoScanFolhetoTable.vue?vue&type=style&index=0&id=11bb4389&scoped=true&lang=css"

import exportComponent from "/home/runner/work/frontend-valora/frontend-valora/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11bb4389"]])

export default __exports__